import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { ActionSheetController, IonSearchbar, ModalController, ToastController, ViewWillEnter } from '@ionic/angular';

import { StorageService } from 'src/app/core/services/behavior/storage.service';
import { AuthenticationService } from 'src/app/core/services/http/authentication.service';
import { KeyboardKeysEnum } from '../../enums/keyboard-keys.enum';
import { ModalRoleEnum } from '../../enums/modal-role.enum';
import { ModalResult } from '../../interfaces/modal-result.interface';
import { ConfiguracaoModel } from '../../models/configuracao.model';
import { ProdutoModel } from '../../models/produto.model';
import { TamanhoResponseModel } from '../../models/tamanho.model';
import { VendasDetalheModel } from '../../models/vendas-detalhe.model';
import { HelpersUtil } from '../../utils/helpers.util';
import { ObservacoesProdutoComponent, ObservacoesProdutoDataClose } from '../observacoes-produto/observacoes-produto.component';
import { SelecionarQtdFatiasDataClose, SelecionarQtdFatiasDialog } from '../selecionar-qtd-fatias/selecionar-qtd-fatias.dialog';

@Component({
  selector: 'app-montar-item',
  templateUrl: './montar-item.component.html',
  styleUrls: ['./montar-item.component.scss'],
})
export class MontarItemComponent implements ViewWillEnter {
  // ModalProps
  private readonly arrItensReadonly: ProdutoModel[];
  readonly arrTamanhos: TamanhoResponseModel[] = [];
  readonly lblTipo: 'PIZZA' | 'LASANHA';
  readonly numeroComanda: number;

  private arrItens: ProdutoModel[] = [];
  private confirmarFechamentoActionSheet: HTMLIonActionSheetElement = null;
  private confirmarFechamentoIsOpen = false;
  private modalRef: HTMLIonModalElement = null;

  @ViewChild('list', { static: false, read: ElementRef }) private list: ElementRef;
  @ViewChild('searchbar', { static: false }) private searchbar: IonSearchbar;

  arrItensFiltrados: ProdutoModel[] = [];
  arrItensSelecionados: VendasDetalheModel[] = [];
  detAtual = new VendasDetalheModel();
  detSelecionado: VendasDetalheModel = null;
  isAutoAtendimento: boolean = false;
  indexTamanhoSelecionado = 0;
  indexProdutoSelecionado = -1;
  isMobile = true;
  tamanhoAtual: TamanhoResponseModel;
  maiorValorItem: boolean;
  totalItens = 0;

  horaAberturaJanela = Date.now();

  constructor(
    private actionSheetCtrl: ActionSheetController,
    private modalCtrl: ModalController,
    private toastCtrl: ToastController,
    private authService: AuthenticationService,
    private storageService: StorageService
  ) {

    const userAgent = window.navigator.userAgent;

    this.isMobile = /Mobile/i.test(userAgent);
  }

  async ionViewWillEnter() {
    this.isAutoAtendimento = this.authService.isAutoAtendimento;

    const configuracoes = await this.storageService.get('configuracoes') as ConfiguracaoModel;

    if (this.lblTipo === 'LASANHA')
      this.maiorValorItem = configuracoes.lasanhaPorMaiorValor;
    else
      this.maiorValorItem = configuracoes.pizzaPorMaiorValor;

    this.modalRef = await this.modalCtrl.getTop();
  }

  adicionarItem(item: ProdutoModel): void {
    let det = this.arrItensSelecionados.find(l => l.codigoProduto === item.codigo);

    const qtdFatias = this.verificarQtdFatias();

    if (qtdFatias === this.tamanhoAtual.tamanho) {
      const mensagem = `Quantidade de fatias para ${this.lblTipo} ${this.tamanhoAtual.nome} deve ser ${this.tamanhoAtual.tamanho}.`;
      this.showToast(mensagem);
      return;
    }

    if (det) {
      det.qtd++;
    } else {
      det = new VendasDetalheModel({
        codigoProduto: item.codigo,
        produto: item,
        qtd: qtdFatias > 0 ? 1 : 0,
        unMedCom: item.unmed,
        codigoFamilia: item.familia.codigo
      });

      this.arrItensSelecionados.unshift(det);
    }

    this.recalcularTotais();

    this.modalRef.backdropDismiss = false;

    this.searchbar.value = '';
    this.searchbar.setFocus();
    this.indexProdutoSelecionado = 0;
    this.filtrarItens('');
    this.setFocus();
  }

  calcularTotalFatia(det: VendasDetalheModel): number | null {
    let total = 0;

    if (det.qtd === 0)
      total = det.produto.valorVenda / this.arrItensSelecionados.length;
    else {
      const fixed = ((det?.qtd / this.tamanhoAtual.tamanho) * det.produto.valorVenda).toFixed(2);

      total = Number.parseFloat(fixed);
    }

    return total;
  }

  async cancel(): Promise<void> {
    if (this.confirmarFechamentoIsOpen) {
      const btnSim = document.querySelector('#btnSimActionSheet') as HTMLButtonElement;

      btnSim.focus();
      return;
    }

    if (this.arrItensSelecionados.length && !this.modalRef.backdropDismiss) {
      const confirmacao = await this.confirmarFechamento();

      if (confirmacao) {
        await this.modalCtrl.dismiss(null, ModalRoleEnum.CANCEL);
      }
    } else {
      await this.modalCtrl.dismiss(null, ModalRoleEnum.CANCEL);
    }
  }

  async confirm(): Promise<void> {
    if (this.validarItens()) return;

    this.validarValoresItem();
    this.preencherObsMateriaPrima();
    this.recalcularQtd();

    const nome = `${this.lblTipo} ${this.tamanhoAtual.nome}`;
    const produto = this.arrItensReadonly.find(l => l.nome === nome);

    this.detAtual.codigoProduto = produto.codigo;
    this.detAtual.produto = produto;
    this.detAtual.qtd = 1;
    this.detAtual.materiaPrima = this.arrItensSelecionados;
    this.detAtual.totalItem = this.totalItens;
    this.detAtual.venda = this.totalItens;
    this.detAtual.unMedCom = produto.unmed;
    this.detAtual.codigoFamilia = produto.familia.codigo;

    const dataClose = new MontarItemDataClose(this.detAtual);

    await this.modalCtrl.dismiss(dataClose, ModalRoleEnum.CONFIRM);
  }

  disableBtnConfirm() {
    if (!this.arrItensSelecionados.length) {
      return true;
    }

    if (this.verificarQtdFatias() === 0) {
      return false;
    }

    if (this.verificarQtdFatias() < this.tamanhoAtual.tamanho) {
      return true;
    }

    return false;
  }

  filtrarItens(value: string): void {
    this.indexProdutoSelecionado = -1;

    const produtoAtivo = this.obterProdutoAtivo();

    if (produtoAtivo)
      produtoAtivo.classList.remove('fam_active');

    if (!value) {
      this.load();
      return;
    }

    value = HelpersUtil.prepareValue(value);

    this.arrItensFiltrados = this.arrItens.filter(l => HelpersUtil.prepareValue(l.nome).includes(value));

    if (this.arrItensFiltrados.length === 1) {
      this.indexProdutoSelecionado = 0;
    }
  }

  private dialogObservacoesIsOpen = false;

  async modalObservacoes(det: VendasDetalheModel): Promise<void> {
    const modal = await this.modalCtrl.create({
      component: ObservacoesProdutoComponent,
      componentProps: {
        det: det
      },
      cssClass: 'full-screen-dialog'
    });

    await modal.present();

    this.dialogObservacoesIsOpen = true;

    const modalResult: ModalResult<ObservacoesProdutoDataClose> = await modal.onWillDismiss();

    HelpersUtil.executeAfterDelay(() => this.dialogObservacoesIsOpen = false);

    if (modalResult.role === ModalRoleEnum.CONFIRM)
      det.obs = modalResult.data.obs;
  }

  async modalQtdFatias(det: VendasDetalheModel) {
    const fatiasRestantes = (this.tamanhoAtual.tamanho - this.verificarQtdFatias()) + det.qtd;

    if (!fatiasRestantes) return;

    const arr: number[] = [];

    for (let i = 0; i < fatiasRestantes; i++) {
      arr.push(i + 1);
    }

    const modal = await this.modalCtrl.create({
      component: SelecionarQtdFatiasDialog,
      componentProps: {
        qtdFatias: arr
      },
      backdropBreakpoint: 1,
      showBackdrop: true,
      cssClass: ['width-auto-dialog', 'height-auto-dialog']
    });

    await modal.present();

    this.dialogObservacoesIsOpen = true;

    const modalResult: ModalResult<SelecionarQtdFatiasDataClose> = await modal.onWillDismiss();

    HelpersUtil.executeAfterDelay(() => this.dialogObservacoesIsOpen = false);

    if (modalResult.role === ModalRoleEnum.CONFIRM) {
      det.qtd = modalResult.data.qtdSelecionada;
    }
  }

  removerItem(item: VendasDetalheModel, index: number): void {
    item.qtd <= 0 ? this.arrItensSelecionados.splice(index, 1) : item.qtd--;

    this.recalcularTotais();

    if (!this.arrItensSelecionados.length) {
      this.modalRef.backdropDismiss = true;
    }
  };

  selecionarItemTable(det: VendasDetalheModel) {
    this.indexProdutoSelecionado = -1;

    if (det === this.detSelecionado)
      this.detSelecionado = null;
    else
      this.detSelecionado = det;
  }

  selecionarItem(element: Element, produtoSelecionado: ProdutoModel): void {
    const produtoAtivo = this.obterProdutoAtivo();

    if (produtoAtivo)
      produtoAtivo.classList.remove('prod_active');

    element.classList.add('prod_active');

    const produto = Object.assign({}, produtoSelecionado);

    const novoProduto = this.prepararNomeItem(produto);

    const det = this.arrItensSelecionados.find(l => l.codigoProduto === novoProduto.codigo);

    if (!det) {
      this.adicionarItem(novoProduto);
    }
  }

  selecionarTamanho(tamanho: TamanhoResponseModel): void {
    HelpersUtil.executeAfterDelay(() => this.searchbar.setFocus());

    if (this.tamanhoAtual == tamanho) return;

    this.tamanhoAtual = tamanho;

    const index = this.arrTamanhos.indexOf(tamanho);

    this.indexTamanhoSelecionado = index;

    this.load();
    this.atualizarValores();
  }

  verificarQtdFatias(): number {
    const qtdFatias = HelpersUtil.sumArray(this.arrItensSelecionados, 'qtd');

    return qtdFatias;
  }

  private atualizarValores(): void {
    const arrNovosItens = [];

    this.arrItensSelecionados.forEach(item => {
      const sabor = item.produto.nome.trim();
      const novoNome = `${this.lblTipo} ${this.tamanhoAtual.nome} ${sabor}`;
      const novoProduto = this.arrItensReadonly.find(l => l.nome === novoNome);

      const produtoPreparado = this.prepararNomeItem(novoProduto);

      arrNovosItens.push(produtoPreparado);
    });

    this.arrItensSelecionados = [];

    arrNovosItens.forEach(l => this.adicionarItem(l));
  }

  private calcularTotalItens(): number | null {
    let total = 0;

    this.arrItensSelecionados.forEach(item => total += this.calcularTotalFatia(item));

    return this.ajustarValor(total);
  }

  private async confirmarFechamento(): Promise<boolean> {
    this.confirmarFechamentoActionSheet = await this.actionSheetCtrl.create({
      header: 'Deseja realmente cancelar?',
      buttons: [
        {
          text: 'Sim',
          role: ModalRoleEnum.CONFIRM,
          id: 'btnSimActionSheet'
        },
        {
          text: 'Não',
          role: ModalRoleEnum.CANCEL,
          id: 'btnNaoActionSheet'
        },
      ],
      backdropDismiss: false
    });

    this.confirmarFechamentoActionSheet.present();

    this.confirmarFechamentoIsOpen = true;

    const btnSim = document.querySelector('#btnSimActionSheet') as HTMLButtonElement;

    HelpersUtil.executeAfterDelay(() => btnSim.focus(), 200);

    const { role } = await this.confirmarFechamentoActionSheet.onWillDismiss();

    HelpersUtil.executeAfterDelay(() => this.confirmarFechamentoIsOpen = false);

    return role === ModalRoleEnum.CONFIRM;
  }

  @HostListener('window:keydown', ['$event'])
  public async handleKeyboardEvent(event: KeyboardEvent) {
    if (this.dialogObservacoesIsOpen) return;

    switch (event.key) {
      case KeyboardKeysEnum.Escape:
        if (this.confirmarFechamentoIsOpen) {
          (await this.actionSheetCtrl.getTop()).dismiss();
          return;
        };

        await this.cancel();
        break;
      case 'ArrowUp':
        if (this.confirmarFechamentoIsOpen) {
          const btnSim = document.querySelector('#btnSimActionSheet') as HTMLButtonElement;

          btnSim.focus();
          return;
        }

        if (!this.tamanhoAtual) {
          this.indexTamanhoSelecionado = HelpersUtil.selectPreviousItem(this.indexTamanhoSelecionado);

          const element = document.querySelector(`[data-tam-index="${this.indexTamanhoSelecionado}"]`);

          if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        } else {
          this.navigate(-1);
          this.setFocus();
        }

        break;
      case 'ArrowDown':
        if (this.confirmarFechamentoIsOpen) {
          const btnNao = document.querySelector('#btnNaoActionSheet') as HTMLButtonElement;

          btnNao.focus();
          return;
        }

        if (!this.tamanhoAtual) {
          this.indexTamanhoSelecionado = HelpersUtil.selectNextItem(this.indexTamanhoSelecionado, this.arrTamanhos.length);

          const element = document.querySelector(`[data-tam-index="${this.indexTamanhoSelecionado}"]`);

          if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        } else {
          this.navigate(1);
          this.setFocus();
        }

        break;
      case 'Enter':
        if (this.confirmarFechamentoIsOpen) return;

        if (!this.tamanhoAtual) {
          const tamanho = this.arrTamanhos[this.indexTamanhoSelecionado];

          if (tamanho) {
            this.selecionarTamanho(tamanho);
          }
        } else {
          const produto: ProdutoModel = this.arrItensFiltrados[this.indexProdutoSelecionado];

          if (produto)
            this.adicionarItem(produto);
        }

        break;

      case 'F5':
        if (this.confirmarFechamentoIsOpen) return;

        event.preventDefault();
        event.stopPropagation();

        if (!this.disableBtnConfirm()) {
          await this.confirm();
        }

        break;

      case KeyboardKeysEnum.Delete:
        if (this.confirmarFechamentoIsOpen) return;

        if (this.detSelecionado) {
          this.detSelecionado.produto.qtd = null;

          const indexDetSelecionado = this.arrItensSelecionados.indexOf(this.detSelecionado);

          this.arrItensSelecionados.splice(indexDetSelecionado, 1);

          this.detSelecionado = null;

          return;
        }

        const itemParaRemover = this.arrItensFiltrados[this.indexProdutoSelecionado];

        if (!itemParaRemover) return;

        const det = this.arrItensSelecionados.find(l => l.codigoProduto === itemParaRemover.codigo);

        if (!det) return;

        const index = this.arrItensSelecionados.indexOf(det);

        this.removerItem(det, index);

        break;
      case KeyboardKeysEnum.F1:
        event.preventDefault();
        event.stopPropagation();

        break;
      case KeyboardKeysEnum.F8:
        if (this.confirmarFechamentoIsOpen) return;

        this.searchbar.setFocus();

        break;

      case KeyboardKeysEnum.ArrowLeft:
        if (this.confirmarFechamentoIsOpen) return;

        this.indexProdutoSelecionado = -1;
        this.arrItensFiltrados = [];
        this.tamanhoAtual = null;

        break;

      case KeyboardKeysEnum.Tab:
        event.stopPropagation();
        event.preventDefault();
        break;
    }
  }

  private load(): void {
    this.selecionarTamanho(this.tamanhoAtual);
    const listaCopia = Array.from(this.arrItensReadonly.filter(l => (l.valorVenda > 0) && (l.codCategoria === this.tamanhoAtual.codigoCategoria)));

    const listaNova: ProdutoModel[] = [];

    listaCopia.forEach(element => {
      const novoItem = this.prepararNomeItem(element);
      listaNova.push(novoItem);
    });

    this.arrItens = listaNova;

    this.arrItensFiltrados = this.arrItens;
  }

  private maiorPreco(): number | null {
    const listaPrecos = this.arrItensSelecionados.map(l => l.produto.valorVenda);

    if (listaPrecos.length <= 0) return null;

    return Math.max.apply(null, listaPrecos);
  }

  private navigate(direction: number) {
    // Atualiza o índice do produto selecionado
    this.indexProdutoSelecionado = Math.min(Math.max(this.indexProdutoSelecionado + direction, 0), this.arrItensFiltrados.length - 1);

    // Verifica se this.list.nativeElement está definido
    if (this.list && this.list.nativeElement) {
      const tableElement = this.list.nativeElement;

      // Procura pelo elemento de linha dentro da tabela com o atributo data-prod-index correspondente ao índice do produto selecionado
      const rowElement = tableElement.querySelector(`[data-prod-index="${this.indexProdutoSelecionado}"]`);

      // Verifica se o elemento de linha foi encontrado antes de rolar para ele
      if (rowElement) {
        // Rola o elemento de linha para a visão, com comportamento de rolagem automática e centralização
        rowElement.scrollIntoView({ behavior: 'auto', block: 'center' });
      }
    }
  }

  private obterProdutoAtivo(): Element | null {
    return document.querySelector('.prod_active');
  }

  private preencherObsMateriaPrima(): void {
    this.arrItensSelecionados.forEach(item => item.obs = `${item.qtd} F - ; ${item.obs ?? ''}`.trim());
  }

  private prepararNomeItem(item: ProdutoModel): ProdutoModel {
    const itemNovo = Object.assign({}, item);

    itemNovo.nome = itemNovo.nome
      .replace(`${this.lblTipo} ${this.tamanhoAtual.nome}`, '')
      .trim();

    return itemNovo;
  }

  private recalcularQtd(): void {
    const qtdFatias = this.verificarQtdFatias();
    const arrLength = this.arrItensSelecionados.length;

    let totalQtds = 0;

    for (const item of this.arrItensSelecionados) {
      if (item.qtd) {
        item.qtd = (item.qtd / qtdFatias) * 1;

        totalQtds += item.qtd;
      } else {
        const qtdStr = (1 / arrLength).toFixed(2);
        const qtd = Number.parseFloat(qtdStr);

        item.qtd = qtd;

        totalQtds += item.qtd;
      }
    }

    const sobraStr = (1 - totalQtds).toFixed(2);

    const ultimoItem = this.arrItensSelecionados[arrLength - 1];

    ultimoItem.qtd += Number.parseFloat(sobraStr);
  }

  private recalcularTotais(): void {
    this.arrItensSelecionados.forEach(item => item.totalItem = this.calcularTotalFatia(item));
    this.arrItensSelecionados.forEach(item => item.venda = this.calcularTotalFatia(item));

    this.totalItens = this.maiorValorItem === true ? this.maiorPreco() : this.calcularTotalItens();
  }

  private setFocus() {
    const element = document.querySelector(`[data-prod-index="${this.indexProdutoSelecionado}"]`);

    const produtoAtivo = this.obterProdutoAtivo();

    if (produtoAtivo)
      produtoAtivo.classList.remove('prod_active');

    if (element)
      element.classList.add('prod_active');
  }

  private async showToast(msg: string): Promise<void> {
    const toast = await this.toastCtrl.create({
      message: msg,
      duration: 2000,
      position: 'middle',
      color: 'tertiary'
    });

    await toast.present();
  }

  private validarItens(): boolean {
    const existeItemSemQtd = this.arrItensSelecionados.find(l => l.qtd === 0);

    return (this.verificarQtdFatias() === this.tamanhoAtual.tamanho) && existeItemSemQtd !== undefined;
  }

  private validarValoresItem() {
    const length = this.arrItensSelecionados.length;
    const ultimoItem = this.arrItensSelecionados[length - 1];
    const arrSemUltimoItem = this.arrItensSelecionados.slice(0, -1);

    const totalItensQuebrado = HelpersUtil.sumArray(arrSemUltimoItem, 'totalItem');

    const valorUltimoItemFixed = (this.totalItens - totalItensQuebrado).toFixed(2);
    const valorUltimoItem = Number.parseFloat(valorUltimoItemFixed);

    ultimoItem.totalItem = valorUltimoItem;
    ultimoItem.venda = valorUltimoItem;
  }

  /**
   * 
   * @param valor 
   * @returns Retorna o valor arredondado, por exemplo: se o valor for 5,36, ele será arredondado para 5,40.
   */
  private ajustarValor(valor: number): number {
    const parteInteira = Math.floor(valor); // Parte inteira do valor
    const parteDecimal = valor - parteInteira; // Parte decimal do valor

    let valorAjustado: number;
    if (parteDecimal > 0) {
      const arredondado = Math.round(parteDecimal * 100); // Arredonda os centavos para o número inteiro mais próximo
      const resto = arredondado % 5; // Calcula o resto da divisão por 5 para arredondar para o múltiplo de 0.05

      if (resto !== 0) {
        const diferenca = 5 - resto; // Calcula a diferença necessária para chegar ao múltiplo de 0.05
        const novoDecimal = (arredondado + diferenca) / 100; // Novo valor decimal ajustado
        valorAjustado = parteInteira + novoDecimal; // Valor total ajustado
      } else {
        valorAjustado = parteInteira + arredondado / 100; // Valor sem necessidade de ajuste
      }
    } else {
      valorAjustado = valor; // Se não houver parte decimal, mantém o valor original
    }

    return valorAjustado;
  }
}

export class MontarItemDataClose {
  constructor(
    public det: VendasDetalheModel
  ) { }
}
